import { Box } from '@mui/material';

interface DashboardAccountsInterface {
  totalValue: number;
  secondValue: number;
  firstColor?: string;
  secondColor?: string;
}

export default function HorizontalTwoValuesChart({
  totalValue,
  secondValue,
  firstColor = '#6FDD98',
  secondColor = '#F29559',
}: DashboardAccountsInterface) {
  const secondValuePercentage = totalValue
    ? (secondValue * 100) / totalValue
    : 100;
  const minWidthWhenHaveValue = 1;
  const totalValueMinWidth = totalValue === 0 ? 0 : minWidthWhenHaveValue;
  const secondValueMinWidth = secondValue === 0 ? 0 : minWidthWhenHaveValue;

  const getOtherRadius = (value: number) => (value ? 0 : 100);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        gap: 1,
      }}
    >
      {!!totalValue && (
        <Box
          sx={{
            width: `calc(${100 - secondValuePercentage}% - 4px)`,
            minWidth: `${totalValueMinWidth}px`,
            maxWidth: '99%',
            height: 8,
            borderRadius: `100px ${getOtherRadius(secondValueMinWidth)}px ${getOtherRadius(secondValueMinWidth)}px 100px`,
            background: firstColor,
          }}
        ></Box>
      )}
      {!!secondValue && (
        <Box
          sx={{
            width: `calc(${secondValuePercentage}% - 4px)`,
            minWidth: `${secondValueMinWidth}px`,
            maxWidth: '99%',
            height: 8,
            borderRadius: `${getOtherRadius(totalValueMinWidth)}px 100px 100px ${getOtherRadius(totalValueMinWidth)}px`,
            background: secondColor,
          }}
        ></Box>
      )}
    </Box>
  );
}
